/**
 * NOTE: I'm doing things a bit hacky here.
 * Normally, controls are rendered with the `controls` array, and
 * that state is owned by Demo. The problem here is that I need to
 * run an effect whenever that state changes, to calculate the
 * actual bounding box sizes. And I want to show that after the
 * component.
 *
 * So, instead, I'm owning the state in this component and rendering
 * the controller manually, outside the `controls` array.
 */

import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import SliderControl from '@/components/Controls/SliderControl';

import FlexDemo from './FlexDemo';
import Output from './Output';

function ShrinkZero() {
  const [width, setWidth] = React.useState(600);

  return (
    <FlexDemo
      centered
      initialValues={{
        '--direction': 'row',
      }}
    >
      {() => (
        <>
          <Output
            state={{ '--gap': '16px' }}
            height={32 + 16 * 2}
            wrapperStyle={{
              width: width + 2 * 2 + 4 * 2,
              padding: 16,
            }}
          >
            <Ball style={{ flexShrink: 0 }} />
            <Stretch />
            <Ball style={{ flexShrink: 0 }} />
          </Output>
          <PseudoControlWrapper>
            <SliderControl
              id="container-width"
              label="Container width"
              min={100}
              max={600}
              value={width}
              setValue={setWidth}
              wrapperStyle={{
                flex: 1,
              }}
            />
          </PseudoControlWrapper>
        </>
      )}
    </FlexDemo>
  );
}

const PseudoControlWrapper = styled.div`
  max-width: 50%;
  display: flex;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
  margin-top: 16px;

  @media ${BREAKPOINTS.mdAndSmaller} {
    max-width: unset;
  }
`;

const Ball = styled.div`
  background-color: hotpink;
  border-radius: 50%;
  width: 32px;
  height: 32px;
`;

const Stretch = styled.div`
  width: 300px;
  height: 32px;
  border-radius: 1000px;
  background: hotpink;
  flex-grow: 1;
`;

export default ShrinkZero;
